module.exports = __webpack_public_path__ + "img/gravier_panache.00e4b013.jpg";